/** Browsers clamp overflow delays to ~1ms; chain timers for longer waits. */
const MAX_SET_TIMEOUT_MS = 2147483647;

export function createSafeTimeoutHandle() {
  let generation = 0;
  let activeTimer = null;

  return {
    clear() {
      generation += 1;
      if (activeTimer != null) {
        clearTimeout(activeTimer);
        activeTimer = null;
      }
    },
    schedule(callback, delayMs) {
      this.clear();
      const gen = generation;
      const run = (remaining) => {
        if (gen !== generation) return;
        if (remaining <= 0) {
          activeTimer = null;
          callback();
          return;
        }
        const wait = Math.min(remaining, MAX_SET_TIMEOUT_MS);
        activeTimer = setTimeout(() => run(remaining - wait), wait);
      };
      run(delayMs);
    },
  };
}
